<div class="container">
  <div *ngIf="isSucces" class="mt-10 bg-green-900 text-center py-4 lg:px-4 mb-5 rounded ">
    <div
      class="p-2 bg-indigo-800 items-center text-indigo-100 leading-none lg:rounded-full flex lg:inline-flex"
      role="alert"
    >
      <span
        class="flex rounded-full bg-indigo-500 uppercase px-2 py-1 text-xs font-bold mr-3"
      >
        OK
      </span>
      <span class="font-semibold mr-2 text-left flex-auto">
        Success Delete,
      </span>
    </div>
  </div>
  <table mat-table [dataSource]="dataSource" class="mat-elevation-z8 mb-96">

    <!--- Note that these columns can be defined in any order.
          The actual rendered columns are set as a property on the row definition" -->

    <!-- Position Column -->
    <ng-container matColumnDef="email">
      <th mat-header-cell *matHeaderCellDef> Email. </th>
      <td mat-cell *matCellDef="let element"> {{element.email}} </td>
    </ng-container>

    <!-- Name Column -->
    <ng-container matColumnDef="numberPhone">
      <th mat-header-cell *matHeaderCellDef> No HP </th>
      <td mat-cell *matCellDef="let element"> {{element.numberPhone}} </td>
    </ng-container>

    <!-- Weight Column -->
    <ng-container matColumnDef="companyName">
      <th mat-header-cell *matHeaderCellDef> companyName </th>
      <td mat-cell *matCellDef="let element"> {{element.companyName }} </td>
    </ng-container>

    <!-- Symbol Column -->
    <ng-container matColumnDef="message">
      <th mat-header-cell *matHeaderCellDef> message </th>
      <td mat-cell *matCellDef="let element"> {{element.message}} </td>
    </ng-container>

    <ng-container matColumnDef="remove">
      <th mat-header-cell *matHeaderCellDef> Remove </th>
      <td mat-cell *matCellDef="let element">
        <img (click)="delete(element._id)" style="cursor:pointer" src="../../../../assets/nft/icons8-remove-64.png" width="30" height="30" alt="">
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>
</div>

